import { useEffect, useState } from "react";

const TEMPLATE_KEY = "fixed_message_template";

export function useFixedTemplate() {
  const [fixedTemplate, setFixedTemplate] = useState<string | null>(null);

  useEffect(() => {
    const saved = localStorage.getItem(TEMPLATE_KEY);
    setFixedTemplate(saved);
  }, []);

  const saveTemplate = (template: string) => {
    localStorage.setItem(TEMPLATE_KEY, template);
    setFixedTemplate(template);
  };

  const deleteTemplate = () => {
    localStorage.removeItem(TEMPLATE_KEY);
    setFixedTemplate(null);
  };

  return { fixedTemplate, saveTemplate, deleteTemplate };
}
